import { render, staticRenderFns } from "./ykt.vue?vue&type=template&id=cfb717be&scoped=true&"
import script from "./ykt.vue?vue&type=script&lang=js&"
export * from "./ykt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb717be",
  null
  
)

export default component.exports